import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Viewer } from '@react-pdf-viewer/core';
// Plugins
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { Worker } from '@react-pdf-viewer/core'; // install this library
import packageJson from '../../../package.json'
// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import './styles.css'

const FileContainer = ({ fileKey }) => {
  var url = useLocation()

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  return (
    <div className='doc-container'>
      {url?.search.includes('pdf') ?
        (
          // <Document
          //   file={`${process.env.REACT_APP_S3_URL}${url?.search?.split('?')[1].charAt(0) !== "/" ? "/" : ""}${url?.search?.split('?')[1]}`}
          //   onLoadSuccess={onDocumentLoadSuccess} onLoadError={(error) => alert('Error while loading document! ' + error.message)}
          // >
          //   {/* <Page pageNumber={pageNumber} /> */}
          //   {Array.from(new Array(numPages), (el, index) => (
          //     <Page key={`page_${index + 1}`} pageNumber={index + 1} />
          //   ))}
          // </Document>
          `${process.env.REACT_APP_S3_URL}${url?.search?.split('?')[1].charAt(0) !== "/" ? "/" : ""}${url?.search?.split('?')[1]}` &&
          <>
            <Worker workerUrl={`https://unpkg.com/pdfjs-dist@${packageJson.dependencies['pdfjs-dist'].replace('^','')}/build/pdf.worker.min.js`}>
              <Viewer fileUrl={`${process.env.REACT_APP_S3_URL}${url?.search?.split('?')[1].charAt(0) !== "/" ? "/" : ""}${url?.search?.split('?')[1]}`}
                plugins={[defaultLayoutPluginInstance]} />
            </Worker>
          </>

        )
        :
        <img src={`${process.env.REACT_APP_S3_URL}${url?.search?.split('?')[1].charAt(0) !== "/" ? "/" : ""}${url?.search?.split('?')[1]}`} />
      }
    </div>
  )
}
export default FileContainer